export enum ItemType {
  File = 'file',
  Folder = 'folder',
  RealFile = 'real-file',
  Board = 'board',
}

export const ITEM_COUNTS_TRANSLATIONS = {
  [ItemType.Folder]: 'item-types.folder',
  [ItemType.File]: 'item-types.file',
};
